export interface TelemetryContext {
  userId?: string;
  userEmail?: string;
  userName?: string;
  role?: string;
  page?: string;
  modal?: string;
  orderPid?: string;
}

let context: TelemetryContext = {};

export const setTelemetryContext = (next: TelemetryContext) => {
  context = { ...context, ...next };
};

export const getTelemetryContext = (): TelemetryContext => context;

export const getTelemetryPage = (): string => context.page ?? '';

/** Freezes the current context so a long-running operation reports where it started. */
export const snapshotTelemetryContext = (): TelemetryContext => ({
  ...context,
});
